import TestApp from './TestApp';

export default TestApp;